import { inject } from "inversify";
import {
    IAddressLookupService,
    IAddressLookupServiceId,
    ICookieService,
    ICookieServiceId,
    IEnquiryFormService,
    IEnquiryFormServiceId,
    ILoggingService,
    ILoggingServiceId,
    IMessagingService,
    IMessagingServiceId,
    ISessionService,
    ISessionServiceId,
    IAnalyticsService,
    IAnalyticsServiceId,
    IHashingService,
    IHashingServiceId,
    Startup,
} from "@se/designsystem-core";
import { IPlatformClientId, IPlatformClient, IApiClientId, IApiClient } from "@se/platform";
import { SearchSupportAutoComplete } from "./components/searchSupportAutoComplete";
import { LiveChatPopupComponent } from "./components/liveChatPopupComponent";
import { FBSConfig } from "./configuration/FBSConfig";
import { FeedbackFormComponent } from "./components/feedbackFormComponent";
import { IFBSFeedbackServiceId, IFBSFeedbackService } from "./services/interfaces/fbsFeedbackService";

class SiteStartup extends Startup {
    constructor(
        @inject(IMessagingServiceId) protected messagingService: IMessagingService,
        @inject(ISessionServiceId) protected sessionService: ISessionService,
        @inject(IEnquiryFormServiceId) protected enquiryFormService: IEnquiryFormService,
        @inject(IAddressLookupServiceId) protected addressLookupService: IAddressLookupService,
        @inject(IPlatformClientId) protected platformClient: IPlatformClient,
        @inject(ICookieServiceId) protected cookieService: ICookieService,
        @inject(ILoggingServiceId) protected loggingService: ILoggingService,
        @inject(IAnalyticsServiceId) protected analyticsTrackingService: IAnalyticsService,
        @inject(IHashingServiceId) protected hashingService: IHashingService,
        @inject(IApiClientId) protected apiClient: IApiClient,
        @inject(IFBSFeedbackServiceId) protected fbsFeedbackService: IFBSFeedbackService,
        @inject(FBSConfig) protected fbsConfig: FBSConfig
    ) {
        super(
            messagingService,
            sessionService,
            enquiryFormService,
            addressLookupService,
            platformClient,
            apiClient,
            cookieService,
            loggingService,
            analyticsTrackingService,
            hashingService
        );
    }

    public start() {
        // call the base start method to boot up common components from DS core
        super.start();

        document.querySelectorAll(".js-search-support").forEach((element: HTMLFormElement) => {
            new SearchSupportAutoComplete(element, this.messagingService, this.appInsights, this.sessionService);
        });

        document.querySelectorAll(".js-feedback-form").forEach((element: HTMLFormElement) => {
            new FeedbackFormComponent(element, this.appInsights, this.messagingService, this.sessionService,this.loggingService, this.analyticsTrackingService, this.fbsFeedbackService);
        });

        document.querySelectorAll(".js-live-chat-popup-component").forEach((element: HTMLElement) => {
            new LiveChatPopupComponent(element, this.messagingService, this.fbsConfig);
        });

    }
}

export { SiteStartup };
